export const translations = {
  es: {
    nav: {
      recovery: "Recuperación",
      services: "Servicios",
      howItWorks: "Cómo funciona",
      faq: "FAQ",
      contact: "Contacto",
      callNow: "Llámame",
      staffLogin: "Iniciar sesión",
      staffLoginShort: "Entrar"
    },
    hero: {
      badge: "Transporte de vehículos profesional",
      title: "La forma más",
      titleHighlight: "rápida",
      titleEnd: "y confiable de mover tu vehículo",
      description: "Trabajamos con una red nacional de transportistas verificados. Soluciones rápidas, seguras y con tarifas asequibles.",
      verified: "Transportistas verificados",
      insured: "Seguro incluido",
      delivery: "Entrega a domicilio",
      formTitle: "Solicita tu presupuesto gratuito",
      pickupLocation: "Lugar de recogida",
      pickupPlaceholder: "Ciudad de origen",
      deliveryLocation: "Lugar de entrega",
      deliveryPlaceholder: "Ciudad de destino",
      pickupDate: "Fecha de recogida",
      deliveryDate: "Fecha de entrega",
      vehicleType: "Tipo de vehículo",
      vehiclePlaceholder: "Ej: Turismo, Moto, Furgoneta",
      name: "Nombre completo",
      namePlaceholder: "Tu nombre",
      email: "Email",
      emailPlaceholder: "tu@email.com",
      phone: "Teléfono",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Solicitar presupuesto",
      successTitle: "¡Solicitud enviada!",
      successDescription: "Nos pondremos en contacto contigo pronto con tu presupuesto personalizado.",
      errorTitle: "Error",
      errorDescription: "Hubo un problema al enviar tu solicitud. Por favor, inténtalo de nuevo."
    },
    stats: {
      vehicles: "+10,000",
      vehiclesLabel: "Vehículos transportados",
      satisfaction: "98%",
      satisfactionLabel: "Clientes satisfechos",
      delivery: "24-72h",
      deliveryLabel: "Entrega promedio"
    },
    howItWorks: {
      title: "¿Cómo funciona?",
      subtitle: "Tu entrega en tres pasos: 1, 2, ¡Go!",
      step1Title: "Solicita presupuesto",
      step1Description: "Rellena el formulario con los detalles de tu transporte y recibe un presupuesto personalizado en minutos.",
      step2Title: "Confirmamos y recogemos",
      step2Description: "Una vez aceptes el presupuesto, coordinamos la recogida de tu vehículo en la ubicación que prefieras.",
      step3Title: "Entregamos tu vehículo",
      step3Description: "Llevamos tu vehículo de forma segura a su destino. Seguimiento en tiempo real incluido."
    },
    services: {
      title: "Nuestros servicios",
      subtitle: "Soluciones completas de transporte",
      national: "Transporte Nacional",
      nationalDesc: "Traslado rápido y seguro de tu vehículo a cualquier punto de España. Cobertura completa en toda la península.",
      international: "Transporte Internacional",
      internationalDesc: "Llevamos tu vehículo a cualquier país de Europa con total garantía y seguimiento en tiempo real.",
      fleet: "Transporte de Flotas",
      fleetDesc: "Soluciones especializadas para empresas con múltiples vehículos. Gestión eficiente y precios competitivos."
    },
    recovery: {
      badge: "Servicio Especializado 24/7",
      leader: "Líderes en Europa",
      title: "Recuperación de Vehículos en toda Europa",
      description: "Líderes europeos en recuperación profesional de vehículos por impagos, alquiler no devuelto y situaciones complejas",
      service1Title: "Impagos y Embargos",
      service1Desc: "Recuperación legal de vehículos por impago de financiación o leasing. Gestión completa y discreta.",
      service2Title: "Alquiler No Devuelto",
      service2Desc: "Localización y recuperación de vehículos de alquiler no devueltos. Cobertura en toda Europa.",
      service3Title: "Recuperación en Toda Europa",
      service3Desc: "Operamos en cualquier país europeo. Red internacional de profesionales especializados.",
      btn1: "Solicitar Recuperación Urgente",
      btn2: "Consulta Rápida",
      whyTitle: "¿Por qué elegirnos?",
      reason1Title: "Respuesta Inmediata",
      reason1Desc: "Atención 24/7. Te respondemos en minutos y actuamos de inmediato.",
      reason2Title: "Cobertura Europea",
      reason2Desc: "Red de profesionales en toda Europa. Localizamos y recuperamos en cualquier país.",
      reason3Title: "100% Legal y Discreto",
      reason3Desc: "Procedimientos legales, documentación completa y máxima confidencialidad.",
      available: "Disponible 24/7",
      allEurope: "Toda Europa",
      legal: "100% Legal",
      confidential: "Confidencial"
    },
    additionalServices: {
      badge: "Servicios Complementarios",
      title: "Más que transporte",
      subtitle: "Ofrecemos servicios adicionales para que tu vehículo llegue en perfectas condiciones",
      itv: "ITV y Homologación",
      itvDesc: "Gestionamos la ITV de tu vehículo antes del transporte para evitar problemas legales.",
      cleaning: "Limpieza Integral",
      cleaningDesc: "Limpieza completa interior y exterior antes de la entrega. Tu vehículo como nuevo.",
      technical: "Pit Stop Técnico",
      technicalDesc: "Revisión técnica completa: niveles, presión neumáticos, luces y sistema de frenos.",
      representation: "Representaciones",
      representationDesc: "Representamos a financieras y concesionarios en operaciones de compraventa, entregas y gestiones comerciales con total profesionalidad.",
      question: "¿Necesitas algún servicio adicional? Consúltanos sin compromiso",
      btn: "Consultar Servicios"
    },
    faq: {
      badge: "¿Tienes dudas?",
      title: "Te ayudamos a resolverlas",
      subtitle: "Las respuestas que buscas, de forma clara y directa",
      openBtn: "Ver respuesta",
      closeBtn: "Cerrar",
      notFound: "¿No encuentras lo que buscas?",
      contactBtn: "Contáctanos por WhatsApp"
    },
    footer: {
      description: "Transporte de vehículos profesional en toda España y Europa. Rápido, seguro y confiable.",
      quickLinks: "Enlaces rápidos",
      contact: "Contacto",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery. Todos los derechos reservados.",
      privacyPolicy: "Política de Privacidad",
      cookiesPolicy: "Política de Cookies"
    }
  },
  en: {
    nav: {
      recovery: "Recovery",
      services: "Services",
      howItWorks: "How it works",
      faq: "FAQ",
      contact: "Contact",
      callNow: "Call me",
      staffLogin: "Log in",
      staffLoginShort: "Log in"
    },
    hero: {
      badge: "Professional vehicle transport",
      title: "The",
      titleHighlight: "fastest",
      titleEnd: "and most reliable way to move your vehicle",
      description: "We work with a nationwide network of verified carriers. Fast, secure solutions with affordable rates.",
      verified: "Verified carriers",
      insured: "Insurance included",
      delivery: "Door-to-door delivery",
      formTitle: "Request your free quote",
      pickupLocation: "Pickup location",
      pickupPlaceholder: "Origin city",
      deliveryLocation: "Delivery location",
      deliveryPlaceholder: "Destination city",
      pickupDate: "Pickup date",
      deliveryDate: "Delivery date",
      vehicleType: "Vehicle type",
      vehiclePlaceholder: "E.g: Car, Motorcycle, Van",
      name: "Full name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "you@email.com",
      phone: "Phone",
      phonePlaceholder: "+34 930 49 15 01",
      submit: "Request quote",
      successTitle: "Request sent!",
      successDescription: "We will contact you soon with your personalized quote.",
      errorTitle: "Error",
      errorDescription: "There was a problem sending your request. Please try again."
    },
    stats: {
      vehicles: "+10,000",
      vehiclesLabel: "Vehicles transported",
      satisfaction: "98%",
      satisfactionLabel: "Satisfied customers",
      delivery: "24-72h",
      deliveryLabel: "Average delivery"
    },
    howItWorks: {
      title: "How it works?",
      subtitle: "Your delivery in three steps: 1, 2, Go!",
      step1Title: "Request quote",
      step1Description: "Fill out the form with your transport details and receive a personalized quote in minutes.",
      step2Title: "We confirm and collect",
      step2Description: "Once you accept the quote, we coordinate the pickup of your vehicle at your preferred location.",
      step3Title: "We deliver your vehicle",
      step3Description: "We safely transport your vehicle to its destination. Real-time tracking included."
    },
    services: {
      title: "Our services",
      subtitle: "Complete transport solutions",
      national: "National Transport",
      nationalDesc: "Fast and secure transport of your vehicle anywhere in Spain. Complete coverage throughout the peninsula.",
      international: "International Transport",
      internationalDesc: "We transport your vehicle to any European country with full guarantee and real-time tracking.",
      fleet: "Fleet Transport",
      fleetDesc: "Specialized solutions for companies with multiple vehicles. Efficient management and competitive prices."
    },
    recovery: {
      badge: "24/7 Specialized Service",
      leader: "Leaders in Europe",
      title: "Vehicle Recovery throughout Europe",
      description: "European leaders in professional vehicle recovery for non-payment, unreturned rentals and complex situations",
      service1Title: "Non-payment and Seizures",
      service1Desc: "Legal recovery of vehicles for financing or leasing non-payment. Complete and discreet management.",
      service2Title: "Unreturned Rental",
      service2Desc: "Location and recovery of unreturned rental vehicles. Coverage throughout Europe.",
      service3Title: "Recovery Throughout Europe",
      service3Desc: "We operate in any European country. International network of specialized professionals.",
      btn1: "Request Urgent Recovery",
      btn2: "Quick Consultation",
      whyTitle: "Why choose us?",
      reason1Title: "Immediate Response",
      reason1Desc: "24/7 service. We respond in minutes and act immediately.",
      reason2Title: "European Coverage",
      reason2Desc: "Network of professionals throughout Europe. We locate and recover in any country.",
      reason3Title: "100% Legal and Discreet",
      reason3Desc: "Legal procedures, complete documentation and maximum confidentiality.",
      available: "Available 24/7",
      allEurope: "All Europe",
      legal: "100% Legal",
      confidential: "Confidential"
    },
    additionalServices: {
      badge: "Additional Services",
      title: "More than transport",
      subtitle: "We offer additional services so your vehicle arrives in perfect condition",
      itv: "ITV and Homologation",
      itvDesc: "We manage your vehicle's ITV before transport to avoid legal problems.",
      cleaning: "Complete Cleaning",
      cleaningDesc: "Complete interior and exterior cleaning before delivery. Your vehicle like new.",
      technical: "Technical Pit Stop",
      technicalDesc: "Complete technical inspection: levels, tire pressure, lights and brake system.",
      representation: "Representations",
      representationDesc: "We represent financial institutions and dealers in sales operations, deliveries and commercial procedures with total professionalism.",
      question: "Need any additional service? Consult us without obligation",
      btn: "Consult Services"
    },
    faq: {
      badge: "Have questions?",
      title: "We help you solve them",
      subtitle: "The answers you seek, clearly and directly",
      openBtn: "View answer",
      closeBtn: "Close",
      notFound: "Can't find what you're looking for?",
      contactBtn: "Contact us on WhatsApp"
    },
    footer: {
      description: "Professional vehicle transport throughout Spain and Europe. Fast, safe and reliable.",
      quickLinks: "Quick links",
      contact: "Contact",
      whatsapp: "WhatsApp",
      rights: "© 2025 AutoGo Delivery. All rights reserved.",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy"
    }
  }
};
